import { CellStatusEnum } from "./calendar-state";

export class CalendarVerificationResult {
    constructor(isVerified, satisfiedWeekIndices, satisfiedDayOfWeekIndices) {
        this.isVerified = isVerified;
        this.satisfiedWeekIndices = satisfiedWeekIndices;
        this.satisfiedDayOfWeekIndices = satisfiedDayOfWeekIndices;
    }
}

export class CalendarVerifier {
    constructor() {

        // REMEMBER OFF BY ONE!!
        this.numReqsPerEventLength = [4, 3, 2, 1];

        this.curReqsPerEventLength = [0,0,0,0];

    }

    getCalendarVerificationResult(levelConfig, calendarState) {    
        let dayOfWeekHintsSatisfied = true;

        // might be better to be more explicit...null are always satisfied
        // and return unsatisfiedIndices...
        let dayOfWeekSatisfiedIndices = [];
        for (let j = 0; j < 7; j++) {
            const dayOfWeekHintJ = levelConfig.dayOfWeekHintsArr[j];
            if (dayOfWeekHintJ == null) {
                // null are satisfied
                continue;
            }

            let numOccupied = 0;
            for (let i = 0; i < 5; i++) {
                if (calendarState.cellGrid[i][j].cellStatus == CellStatusEnum.occupied) {
                    numOccupied++;
                }
            }

            if (numOccupied === dayOfWeekHintJ) {
                dayOfWeekSatisfiedIndices.push(j);
            }
            else {
                dayOfWeekHintsSatisfied = false;
            }
        }

        let weekHintsSatified = true;
        let weekSatisfiedIndices = [];

        for (let i = 0; i < 5; i++) {
            const weekHintI = levelConfig.weekHintsArr[i];
            if (weekHintI == null) {
                continue;
            }

            let numOccupied = 0;
            for (let j = 0; j < 7; j++) {
                if (calendarState.cellGrid[i][j].cellStatus == CellStatusEnum.occupied) {
                    numOccupied++;
                }
            }

            if (numOccupied === weekHintI) {
                weekSatisfiedIndices.push(i);
            }
            else {
                weekHintsSatified = false;
            }
        }

        // now check for segments!
        for (let i = 0; i < this.curReqsPerEventLength.length; i++) {
            this.curReqsPerEventLength[i] = 0;
        }

        let curSegmentLength = -1;

        // I would rather use a hashmap here
        let anySegmentLengthOutOfRange = false;

        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 7; j++) {
                const cellStatus = calendarState.cellGrid[i][j].cellStatus;

                if (cellStatus === CellStatusEnum.occupied) {
                    // haven't started a segment yet
                    if (curSegmentLength <= 0)
                    {
                        curSegmentLength = 1;
                    }
                    else
                    {
                        curSegmentLength++;
                    }
                }
                else
                {
                    if (curSegmentLength > 0)
                    {
                        const segmentLengthIdx = curSegmentLength - 1;
                        if (segmentLengthIdx >= this.curReqsPerEventLength) {
                            anySegmentLengthOutOfRange = true;
                            continue;
                        }
                        else {
                            this.curReqsPerEventLength[segmentLengthIdx]++;
                        }


                        curSegmentLength = -1;
                    }
                }
            }
        }

        if (curSegmentLength > 0)
        {
            const segmentLengthIdx = curSegmentLength - 1;
            if (segmentLengthIdx >= this.curReqsPerEventLength) {
                anySegmentLengthOutOfRange = true;
            }
            else {
                
            }

            this.curReqsPerEventLength[segmentLengthIdx]++;
        }

        let allSegmentsLengthsWithin4AreEqual = true;
        for (let i = 0; i < this.numReqsPerEventLength.length; i++) {
            if (this.curReqsPerEventLength[i] !== this.numReqsPerEventLength[i]) {
                allSegmentsLengthsWithin4AreEqual = false;
                break;
            }
        }

        const segmentsSatisfied = !anySegmentLengthOutOfRange && allSegmentsLengthsWithin4AreEqual;

        const isCompletelySatisfied = segmentsSatisfied && dayOfWeekHintsSatisfied && weekHintsSatified;

        return new CalendarVerificationResult(isCompletelySatisfied, weekSatisfiedIndices, dayOfWeekSatisfiedIndices);
    }
}